import cookiesPolicy from './cookies_policy';

export default () => {
  document.getElementById('no-javascript').remove();
  cookiesPolicy();
};
